import $ from 'jquery';

import { initializeApp } from 'firebase/app';
import { getMessaging, getToken, onMessage } from 'firebase/messaging';

import appAjax from './ajax';
import appUi from './ui';

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
};

const app = initializeApp(firebaseConfig);
const messaging = getMessaging(app);

const initFirebaseMessaging = () => {
  // Get FCM token
  getToken(messaging, {
    vapidKey: process.env.REACT_APP_FIREBASE_VAPID_KEY,
  })
    .then((token) => {
      // console.log('FCM Token:', token);
      // appAjax.copyableMessage(token, 'Your FCM Token');

      // Send this token to backend
      appAjax.FCM_TOKEN = token;
      appAjax.saveFcmToken(appAjax.FCM_TOKEN, (response) => {
        //-- Callback if needed after saving token to backend
      });
    })
    .catch((error) => {
      console.error('Error getting FCM token:', error);
      if (appAjax.CHATBOX) {
        appAjax.alertMessage('Error getting FCM token.');
      }
    });
};

export { app, messaging, firebaseConfig, getToken, onMessage, initFirebaseMessaging };
